import { Button } from "@afas-doe-maar/ui/Button";
import { CircleAlertIcon } from "lucide-react";
import { useCallback } from "react";

interface ErrorScreenProps {
  mode?: "detailed" | "minimal";
  error: unknown;
}

export function ErrorScreen({
  error,
  mode = import.meta.env?.MODE === "development" ? "detailed" : "minimal",
}: ErrorScreenProps) {
  const errorType = attemptGetFromUnknown(error, "type") ?? null;
  const message = attemptGetFromUnknown(error, "message") ?? "Unknown error";

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-4 text-center">
      <CircleAlertIcon />

      <p className="text-lg font-bold">
        Oh no!
        <br />
        Something went wrong 😢
      </p>

      <Button onClick={handleReload}>Refresh the page</Button>

      {mode === "detailed" ? (
        <pre className="whitespace-pre-wrap">
          {errorType && `[${errorType}]:`}
          {message.includes("\n") ? message : `\n${message}`}
        </pre>
      ) : (
        <p className="text-muted-foreground">
          If the error persists, just look around and enjoy the moment. We will fix it soon.
        </p>
      )}
    </div>
  );
}

function attemptGetFromUnknown(unknown: unknown, key: string) {
  return typeof unknown === "object" && unknown !== null && key in unknown
    ? (unknown as any)[key]
    : undefined;
}
